import React from 'react'
import SCR from '../components/SCR.js';
import RezCentral from '../components/RezCentral.js';
import VehicleClass from '../models/VehicleClass.js';
import PersonalInfo from '../models/PersonalInfo.js';
import Location from '../models/Location.js';
import {Container, Row, Col, Button, Modal, Form, Spinner} from 'react-bootstrap/';
//import ReactPixel from 'react-facebook-pixel';

export default class LookupRez extends React.Component {
  constructor(props){
      super(props);

      this.state = {
        loading : false,
        confirmationNum : '',
        lastName : '',
        getRez : {},
        showModal : false,
        rezObj : {},
        rezCanceled : false,
        errors : {},
        showLookupRezForm : true,
        errorMessage : ''
      }

      this.lookupRez = this.lookupRez.bind(this);
      this.handleInputChange = this.handleInputChange.bind(this);
      this.cancelReservation = this.cancelReservation.bind(this);
      this.cancelReservationConfirm = this.cancelReservationConfirm.bind(this);
      this.handleClose = this.handleClose.bind(this);
      this.modifyStepClick = this.modifyStepClick.bind(this);
      //this.modifyPersonalInfoClick = this.modifyPersonalInfoClick.bind(this);
      //this.modifyDatesClick = this.modifyDatesClick.bind(this);
      //this.modifyExtrasClick = this.modifyExtrasClick.bind(this);
      //this.modifyVehicleClick = this.modifyVehicleClick.bind(this);
      this.validateFormInputs = this.validateFormInputs.bind(this);
      this.goBack = this.goBack.bind(this);
      this.goBackHome = this.goBackHome.bind(this);
  }

  componentDidMount() {
    // **** TESTING NEED TO REMOVE
    //this.setState({ confirmationNum : 'WSC0006E68', lastName : 'doe'});

    var page = '/lookup';
    window.history.replaceState(null, '', page);
    SCR.fireTracking(page, {});

    setTimeout(function(){
				window.history.replaceState(null, '', '/reservation');
			}, 2000);
    /*const options = {
      autoConfig: true,     // set pixel's autoConfig
      debug: false,         // enable logs
    };
    ReactPixel.init('1516147002023231', options);
    ReactPixel.pageView();*/
  }

  handleInputChange(event){
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  lookupRez(){
    //console.log('lookup rez')
    var confirmationNum = this.state.confirmationNum;
    var lastName = this.state.lastName;

    if (this.validateFormInputs()) {

      // show loading spinner
      this.setState({loading : true, errorMessage : ''});

      RezCentral.getRez({ confirmationNum : confirmationNum, newRateId : true})
      .then((getRezRsp) => {

        //console.log(getRezRsp.data.renterLast.toLowerCase())
        if(getRezRsp.message === ''){
          if(getRezRsp.data.renterLast.toLowerCase() === lastName.toLowerCase()){
            this.setState({
              getRez: getRezRsp.data,
              showLookupRezForm : false,
              loading: false
            });
          }else{
            //alert('last name does not match');
            this.setState({ loading: false, errorMessage : 'Could not find reservation with that last name' });
          }
        }
        else{
          //alert(getRezRsp.message)
          this.setState({ loading: false, errorMessage : getRezRsp.message });
        }
      });
    }
  }

  getDateString(str){
    if(typeof str === "undefined" || str === '')
      return '';

    var parts = str.split(' ');

    var dt = parseInt(parts[0].substring(0, 2)) + '/' + parseInt(parts[0].substring(2, 4)) + '/' + parseInt(parts[0].substring(4, 8));
    return dt;
  }

  loadRezData(){
    //console.log('laoding')
    var getRez = this.state.getRez;

    var pl = new Location();
    pl.locationId = getRez.rentalLocationID;
    pl.locationCity = SCR.getCity(getRez.rentalLocationID);
    pl.date = new Date(Date.parse(this.getDateString(getRez.pickupDateTime.substring(0, 8))));//new Date(Date.parse('2022-01-18 00:00:00'));
    pl.time = getRez.pickupDateTime.substring(9, 17);
    var dl = new Location();
    dl.locationId = getRez.returnLocationID;
    dl.locationCity = SCR.getCity(getRez.returnLocationID);
    dl.date = new Date(Date.parse(this.getDateString(getRez.returnDateTime.substring(0, 8))));//new Date(Date.parse('2022-01-19 00:00:00'));
    dl.time = getRez.returnDateTime.substring(9, 17);
    var vc = new VehicleClass();
    vc.setClass(getRez.classCode);
    vc.setTotalCharges(getRez.totalPricing.totalCharges)
    vc.setRateId(getRez.rateID);
    vc.setModelDesc(getRez.modelDesc);
    var pi = new PersonalInfo();
    if(getRez.renterDOB !== '')
      pi.dob = new Date(Date.parse(getRez.renterDOB));

    pi.firstName = getRez.renterFirst;
    pi.lastName = getRez.renterLast;
    pi.phone = getRez.renterCellPhone;
    pi.email = getRez.emailAddress;
    pi.termsAndConditions = getRez.termsAndConditions === 'Y' ? true : false;

    var extras = [];
    if(getRez.dailyExtras !== null){
      getRez.dailyExtras.forEach((extra) => {
        if(extra.autoApplied === 'FALSE')
          extras.push(extra.extraCode);
      });
    }
    var discountCode = getRez.discountCode;
    var confirmNum = this.state.confirmationNum;

    // get new rateid
    /*return this.getNewRateId(
      getRez.rentalLocationID,
      getRez.returnLocationID,
      getRez.pickupDateTime,
      getRez.returnDateTime,
      getRez.discountCode,
      getRez.extras,
      getRez.classCode
    ).then( data => {
      //console.log(data)
      if(data.message !== '')
        return { message : data.message };

      vc.setRateId(data.rateId);*/

      return {
          pickup : pl,
          dropoff : dl,
          discountCode : discountCode,
          vehicleClass : vc,
          extras : extras,
          personalInfo : pi,
          confirmationNum : confirmNum,
          message : ''
      };
    //});
  }

  modifyStepClick(step){
    //console.log(step)
    var self = this;
    var data = this.loadRezData();
    //.then(data => {
      //console.log(data)
      if(data.message === ''){
        self.props.loadDetails(data.confirmationNum, data.pickup, data.dropoff, data.discountCode, data.vehicleClass, data.extras, data.personalInfo);
        // go to step
        self.props.returnToStep(step);
      }else{
        this.setState({ errorMessage : data.message});
      }
    //});
  }

  /*getNewRateId(pickupLocationId, dropoffLocationId, pickupDateTime, dropoffDateTime, discountCode, extras, classCode){
    var rateData = {
      pickupLocationId : pickupLocationId,
      dropoffLocationid : dropoffLocationId,
      pickupDateTime : pickupDateTime,
      dropoffDateTime : dropoffDateTime,
      discountCode : discountCode,
      extras : extras
    };

    return RezCentral.getRates(rateData)
    .then(data => {
      if(data.message !== '')
        return { message : data.message, rateId : ''};

      var rentalList = [];
      var rateId = '';
      if(typeof data.data.rateProduct !== "undefined")
        rentalList = data.data.rateProduct;

      rentalList.forEach(rental => {
          if(rental.classCode === classCode)
            rateId = rental.rateID;
      });

      return { message : '', rateId : rateId};
    });
  }*/

  cancelReservationConfirm(){
    // call cancel
    var confirmationNum = this.state.confirmationNum;
    RezCentral.cancelRez(confirmationNum)
    .then( (data) => {
      //console.log(data.data.message)
      //console.log(data.data.message.indexOf(confirmationNum))
      if(data.message !== '')
        this.setState({ rezCanceledMessage : data.message });
      else if(data.data.message.indexOf(confirmationNum) > -1){
        var getRez = this.state.getRez;
        getRez.reservationStatus = 'CANCELLED';
        this.setState({ getRez : getRez, rezCanceledMessage : 'Reservation canceled successfully' })
      }
    });
  }

  validateFormInputs(){
    var confirmationNum = this.state.confirmationNum;
    var lastName = this.state.lastName;

    let errors = {};
    let formIsValid = true;

    if (!confirmationNum) {
      formIsValid = false;
      errors.confirmationNum = "Cannot be empty";
    }

    if (!lastName) {
      formIsValid = false;
      errors.lastName = "Cannot be empty";
    }

    this.setState({ errors: errors });
    return formIsValid;
  }

  goBack(){
      this.setState({showLookupRezForm : true, getRez : {}});
  }

  goBackHome(){
      this.props.returnToStep(1);
  }

  // modal
  cancelReservation(){
    this.setState({showModal : true});
  }
  handleClose(){
    this.setState({showModal : false});
  }

  render(){
    var Reservation, RezModal, Canceled = [];

    if(Object.keys(this.state.getRez).length > 0){
      var Extras, ExtrasList = [];
      if(this.state.getRez.dailyExtras !== null){
        //console.log(this.state.getRez.dailyExtras)
        ExtrasList = this.state.getRez.dailyExtras.map(
          (extra, index) => {
            //console.log(extra.extraCode)
            if(extra.autoApplied !== 'TRUE'){
              return (<Row key={extra.extraCode + '-' + index}>
                <Col><span>{extra.extraDesc}</span></Col>
              </Row>);
            }else{
              return ("");
            }
          });

        Extras =
        <Row>
          <Col className="mb-3">
            <b>Extras</b><br/>
            {ExtrasList}
          </Col>
          <Col className="d-flex justify-content-end">{ this.state.getRez.reservationStatus === 'ACTIVE' ? <a href="#" onClick={() => this.modifyStepClick(3)}>EDIT</a> : ""}</Col>
        </Row>
      }
      Reservation =
      <Container fluid>
        <h4>Reservation Info</h4>
        {
          this.state.getRez.reservationStatus === 'CANCELLED' ?
            <Row className="mb-3">
              <Col xs={12} className="text-danger"><b>Reservation has been canceled</b></Col>
            </Row>
          : ""
        }
        <Row>
          <Col>
            <b>Customer Info</b> <br/>
            {this.state.getRez.renterFirst} {this.state.getRez.renterLast} <br/>
            {this.state.getRez.renterCellPhone}<br/>
            {this.state.getRez.emailAddress}
          </Col>
          <Col className="d-flex justify-content-end">{ this.state.getRez.reservationStatus === 'ACTIVE' ? <a href="#" onClick={() => this.modifyStepClick(4)}>EDIT</a> : ""}</Col>
        </Row>
        <Row>
          <Col>
            <b>Pick up</b><br/>
            {SCR.getCity(this.state.getRez.rentalLocationID)} <br/>
            {SCR.fixDateString(this.state.getRez.pickupDateTime)}
          </Col>
          <Col className="d-flex justify-content-end">{ this.state.getRez.reservationStatus === 'ACTIVE' ? <a href="#" onClick={() => this.modifyStepClick(1)}>EDIT</a> : ""}</Col>
        </Row>
        <Row>
          <Col>
            <b>Drop off</b><br/>
            {SCR.getCity(this.state.getRez.returnLocationID)} <br/>
            {SCR.fixDateString(this.state.getRez.returnDateTime)}
          </Col>
          <Col className="d-flex justify-content-end">{ this.state.getRez.reservationStatus === 'ACTIVE' ? <a href="#" onClick={() => this.modifyStepClick(1)}>EDIT</a> : ""}</Col>
        </Row>
        {Extras}
        <Row>
          <Col>
            <b>Vehicle</b><br/>
            {this.state.getRez.modelDesc}<br/>
            <img src={this.state.getRez.classImageURL} alt="" />
          </Col>
          <Col className="d-flex justify-content-end">{ this.state.getRez.reservationStatus === 'ACTIVE' ? <a href="#" onClick={() => this.modifyStepClick(2)}>EDIT</a> : ""}</Col>
        </Row>
        <Row>
          <Col xs={2} className="mb-3">
            <b>Total</b><br/>
            ${this.state.getRez.totalPricing.totalCharges}
          </Col>
        </Row>
        <Row>
          <Col>
            <Button onClick={this.goBack}>Go Back</Button>
            { this.state.getRez.reservationStatus === 'ACTIVE' ?
              <Button onClick={this.cancelReservation}>Cancel Reservation</Button>
            : "" }
          </Col>
        </Row>
        <Row className="mt-3">
          <Col className="text-danger">{this.state.errorMessage}</Col>
        </Row>
      </Container>;

      RezModal =
        <>
        <Modal show={this.state.showModal} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Cancel Reservation</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you want to cancel your reservation?</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleClose}>
              Close
            </Button>
            <Button variant="primary" onClick={this.cancelReservationConfirm}>
                Cancel Reservation
            </Button><br/>
            <p className="text-danger">{this.state.rezCanceledMessage}</p>
          </Modal.Footer>
        </Modal>
      </>;
    }

    var LookupRezForm = [];
    if(this.state.showLookupRezForm){
      LookupRezForm =
        <>
        <Row>
          <Col>
          <h3>Already have a Reservation?</h3>
          <h3>View/Modify your Reservation</h3>

          <p>Please enter your confirmation number to view your reservation</p>
          </Col>
        </Row>

        <Form>
          <Row className="mb-3">
            <Col>
              <label className="form-label">Confirmation Number *</label>
              <Form.Control type="text" name="confirmationNum"
              //className="form-control"
              className={this.state.errors.confirmationNum ? 'error' : ''}
              onChange={this.handleInputChange} />
            </Col>
          </Row>

          <Row className="mb-4">
            <Col>
              <label className="form-label">Last Name *</label>
              <Form.Control type="text" name="lastName"
                className={this.state.errors.lastName ? 'error' : ''}
                onChange={this.handleInputChange}
               />
            </Col>
          </Row>
          <Row>
              <Col>
                <Button onClick={this.goBackHome}>Go Back</Button>
                <Button onClick={this.lookupRez} disabled={this.state.loading ? true : false}>
                  {this.state.loading ?
                  <><Spinner animation="border" role="status"></Spinner> <span>Loading...</span></>  : "View Reservation" }
                </Button>
              </Col>
          </Row>
          <Row className="mt-3">
            <Col className="text-danger">{this.state.errorMessage}</Col>
          </Row>
        </Form>
        </>;
    }

    /*if(this.state.rezCanceled){
      Canceled =
      <Row>
        <Col>
          <p>Your reservation has been canceled.  You have been emailed a confirmation</p>
          <p>{this.state.rezCanceledMessage}</p>
        </Col>
      </Row>
    }*/

    return (
      <Container id="lookup-container" xs="responsive">
        {LookupRezForm}
        {Reservation}

        {RezModal}

        {Canceled}
      </Container>
    );
  }
}
